import type { Role } from '@/features/auth/types'

/**
 * Mock mode lets you click through the whole console with no backend and no
 * real login.
 *
 * Two independent guards, both required:
 *   1. VITE_MOCK_API=true  — opt in explicitly
 *   2. import.meta.env.DEV — true only under `pnpm dev`
 *
 * A production build therefore cannot serve mock data even if the env var is
 * set by accident. The fixtures are dynamically imported behind this flag, so
 * they never land in the prod bundle either.
 */
export const IS_MOCK = import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'true'

const ROLE_KEY = 'cwc-mock-role'
const SIGNED_OUT_KEY = 'cwc-mock-signed-out'

export function getMockRole(): Role {
  return localStorage.getItem(ROLE_KEY) === 'ops' ? 'ops' : 'super'
}

export function setMockRole(role: Role) {
  localStorage.setItem(ROLE_KEY, role)
}

export function isMockSignedOut(): boolean {
  return localStorage.getItem(SIGNED_OUT_KEY) === 'true'
}

export function setMockSignedOut(signedOut: boolean) {
  localStorage.setItem(SIGNED_OUT_KEY, String(signedOut))
}
